import { Tile } from "../blueprint/dashboards/entities/tile";

export class BlueprintDashboardDataBuilder {
  private name: string;
  private tiles: Tile[];

  constructor(name: string, tiles: Tile[]) {
    this.name = name;
    this.tiles = tiles;
  }

  build() {
    return {
      name: this.name,
      data: {
        tiles: this.tiles,
      },
    };
  }
}
